import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  fetchOptions, fetchSettings, clearEmailGroup, updateSettings
} from 'account/ducks/notification_settings';
import { atAdmin } from 'common/utils';
import NotificationSettings from 'account/components/notification_settings';

export function mapStateToProps(state) {
  const { notificationSettings, user } = state;
  const atAdminSite = atAdmin(state);
  const profileData = atAdminSite? state.admin.people.currentUser : user.profile_data;
  const userId = profileData.id;
  const emailGroup = notificationSettings.data ? notificationSettings.data.email_group : {};
  const isCustomGroup = Object.keys(emailGroup).length === 0;

  return {
    ...notificationSettings,
    atAdmin: atAdminSite,
    user: profileData,
    isCustomGroup,
    userId,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchOptions,
    fetchSettings,
    clearEmailGroup,
    updateSettings,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationSettings);



// WEBPACK FOOTER //
// ./account/containers/notification_settings.js